<ul *ngIf="tree" class="tree-view">
<t-select-tree-item [item]="tree.rootItem" [treeComponent]="this"></t-select-tree-item>
</ul>

<div *ngIf="loading" class="empty-table compact">
  <p>Chargement...</p>
</div>
